export const Vadodara = {
    title: "Vadodara",
    title1: "(Royal)",
    attractions: [
        {
            name: "Laxmi Vilas Palace",
            description: "One of the largest private residences in the world, Laxmi Vilas Palace was built by Maharaja Sayajirao Gaekwad III in 1890. This stunning palace showcases Indo-Saracenic architecture and houses a museum with royal artifacts, paintings, and sculptures.",
            location: "J N Marg, Vadodara",
            timings: "9:30 AM to 5:00 PM",
            ticket: "₹200 for Indians, ₹400 for Foreigners",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the palace architecture",
                "Visit the museum",
                "Enjoy the golf course nearby",
                "Photography of the palace and gardens",
                "Learn about the Gaekwad dynasty"
            ],
            mapLink: "https://maps.app.goo.gl/example1",
        },
        {
            name: "Sayaji Baug",
            description: "A sprawling garden spread over 113 acres, Sayaji Baug is a popular spot for locals and tourists. It houses a zoo, a planetarium, a toy train, and the Baroda Museum & Picture Gallery.",
            location: "Near Vadodara Railway Station",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry (Additional charges for zoo and museum)",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Stroll through the gardens",
                "Visit the zoo and planetarium",
                "Explore the Baroda Museum",
                "Enjoy the toy train ride",
                "Picnic with family and friends"
            ],
            mapLink: "https://maps.app.goo.gl/example2",
        },
        {
            name: "Baroda Museum & Picture Gallery",
            description: "Located within Sayaji Baug, this museum is one of the oldest in Gujarat. It houses a rich collection of art, sculptures, and artifacts, including works by European masters and ancient Egyptian relics.",
            location: "Sayaji Baug, Vadodara",
            timings: "10:30 AM to 5:00 PM",
            ticket: "₹20 for Indians, ₹150 for Foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the art and sculpture galleries",
                "Learn about ancient artifacts",
                "Photography (where allowed)",
                "Visit the natural history section",
                "Attend special exhibitions"
            ],
            mapLink: "https://maps.app.goo.gl/example3",
        },
        {
            name: "Champaner-Pavagadh Archaeological Park",
            description: "A UNESCO World Heritage Site, this park is home to ancient temples, mosques, and forts. It is a treasure trove of history and architecture, reflecting the blend of Hindu and Islamic cultures.",
            location: "Pavagadh Hill, Near Vadodara",
            timings: "8:00 AM to 6:00 PM",
            ticket: "₹40 for Indians, ₹600 for Foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the ancient temples and mosques",
                "Hike up Pavagadh Hill",
                "Visit the Kalika Mata Temple",
                "Photography of the ruins",
                "Learn about the history of the site"
            ],
            mapLink: "https://maps.app.goo.gl/example4",
        },
        {
            name: "Sursagar Lake",
            description: "A serene lake located in the heart of Vadodara, Sursagar Lake is famous for its towering statue of Lord Shiva in the middle. It is a popular spot for evening walks and photography.",
            location: "City Center, Vadodara",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Evening walk around the lake",
                "Photography of the Shiva statue",
                "Enjoy the peaceful ambiance",
                "Visit nearby markets",
                "Relax by the lake"
            ],
            mapLink: "https://maps.app.goo.gl/example5",
        },
        {
            name: "EME Temple (Dakshinamurti Temple)",
            description: "A unique temple dedicated to Lord Shiva, the EME Temple is made entirely of aluminum and is maintained by the Indian Army. It is known for its modern architecture and spiritual ambiance.",
            location: "EME Road, Vadodara",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Meditate in the peaceful environment",
                "Explore the unique architecture",
                "Attend the evening aarti",
                "Photography",
                "Learn about the temple's history"
            ],
            mapLink: "https://maps.app.goo.gl/example6",
        },
        {
            name: "Kirti Mandir",
            description: "A memorial dedicated to the Gaekwad dynasty, Kirti Mandir is a beautiful structure with intricate carvings and murals. It houses the cenotaphs of the royal family members.",
            location: "Near Laxmi Vilas Palace, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹10 for Indians, ₹50 for Foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the memorial architecture",
                "Learn about the Gaekwad dynasty",
                "Photography of the carvings and murals",
                "Visit nearby Laxmi Vilas Palace",
                "Attend cultural events (if any)"
            ],
            mapLink: "https://maps.app.goo.gl/example7",
        },
        {
            name: "Nazarbaug Palace",
            description: "A historic palace built by Maharaja Sayajirao Gaekwad III, Nazarbaug Palace is known for its stunning architecture and royal artifacts. It is a lesser-known gem in Vadodara.",
            location: "Nazarbaug, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹50 for Indians, ₹100 for Foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the palace architecture",
                "Learn about the royal artifacts",
                "Photography",
                "Visit nearby markets",
                "Enjoy the peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/example8",
        },
        {
            name: "Ajwa Nimeta Garden",
            description: "A beautiful garden located near the Ajwa Reservoir, this spot is known for its musical fountain and lush greenery. It is a popular picnic spot for families.",
            location: "Ajwa Road, Vadodara",
            timings: "9:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Enjoy the musical fountain show",
                "Picnic with family and friends",
                "Photography",
                "Stroll through the gardens",
                "Relax in the peaceful environment"
            ],
            mapLink: "https://maps.app.goo.gl/example9",
        },
        {
            name: "Tambekar Wada",
            description: "A historic mansion known for its intricate wooden carvings and murals, Tambekar Wada offers a glimpse into the life of the 19th-century elite in Vadodara.",
            location: "Dandia Bazaar, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹20 for Indians, ₹100 for Foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the wooden carvings and murals",
                "Learn about the history of the mansion",
                "Photography",
                "Visit nearby Dandia Bazaar",
                "Attend cultural events (if any)"
            ],
            mapLink: "https://maps.app.goo.gl/example10",
        },
        {
            name: "Vadodara Museum and Art Gallery",
            description: "A part of the Baroda Museum complex, this gallery showcases a rich collection of paintings, sculptures, and artifacts from around the world.",
            location: "Sayaji Baug, Vadodara",
            timings: "10:30 AM to 5:00 PM",
            ticket: "₹20 for Indians, ₹150 for Foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the art and sculpture galleries",
                "Learn about ancient artifacts",
                "Photography (where allowed)",
                "Visit the natural history section",
                "Attend special exhibitions"
            ],
            mapLink: "https://maps.app.goo.gl/example11",
        },
        {
            name: "Pratap Vilas Palace",
            description: "A stunning palace built in the Indo-Saracenic style, Pratap Vilas Palace is now used as a railway training academy. It is known for its grand architecture and lush gardens.",
            location: "Near Lalbaug, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "Permission required for entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the palace architecture",
                "Photography",
                "Stroll through the gardens",
                "Learn about its history",
                "Visit nearby Lalbaug"
            ],
            mapLink: "https://maps.app.goo.gl/example12",
        },
        {
            name: "Makarpura Palace",
            description: "A beautiful palace built by Maharaja Sayajirao Gaekwad III, Makarpura Palace is known for its Italian-style architecture and lush gardens. It is now used as a training center for the Indian Air Force.",
            location: "Makarpura, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "Permission required for entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the palace architecture",
                "Photography",
                "Stroll through the gardens",
                "Learn about its history",
                "Visit nearby Makarpura GIDC"
            ],
            mapLink: "https://maps.app.goo.gl/example13",
        },
        {
            name: "Sardar Patel Planetarium",
            description: "Located within Sayaji Baug, this planetarium offers educational shows about astronomy and the universe. It is a great place for both kids and adults.",
            location: "Sayaji Baug, Vadodara",
            timings: "12:00 PM to 8:00 PM",
            ticket: "₹30 for Adults, ₹20 for Kids",
            bestTimeToVisit: "Afternoon",
            activities: [
                "Attend the planetarium shows",
                "Learn about astronomy",
                "Explore Sayaji Baug",
                "Photography",
                "Visit the nearby museum"
            ],
            mapLink: "https://maps.app.goo.gl/example14",
        },
        {
            name: "Nyay Mandir",
            description: "A historic courthouse built during the reign of Maharaja Sayajirao Gaekwad III, Nyay Mandir is known for its grand architecture and historical significance.",
            location: "City Center, Vadodara",
            timings: "10:00 AM to 5:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the courthouse architecture",
                "Photography",
                "Learn about its history",
                "Visit nearby markets",
                "Attend cultural events (if any)"
            ],
            mapLink: "https://maps.app.goo.gl/example15",
        },
    ]
};